// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3XjeF","noInteraction":"EventWrapper_noInteraction__1pyJd","pointerPassthrough":"EventWrapper_pointerPassthrough__2RwZa"};